<template>
    <v-row class="fill-height">
        <v-col>
            <v-card
                flat
            >

                <v-card-title class="pt-1">
                    <v-btn
                        small
                        @click="$router.go(-1)"
                        class="mr-4 btn-back"
                    >
                        <v-icon> mdi-arrow-left</v-icon>
                        Voltar
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn
                        class="btn-new"
                        :to="{ name: 'financialAddAccounts', params: {} }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="text-center">
                        <v-col cols="12" md="12" sm="12" xs="12">
                            <v-row>
                                <v-col class="text-h5 text-left lyndus-color">
                                    Contas de Movimento
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=12 sm=12 md="4" v-for="movAcc in filteredData"
                                       v-bind:key="'m'+movAcc.id">
                                    <v-card
                                        class="mx-auto fill-height text-left" tile
                                        style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="10" xs="10">
                                                    <b>Nome:</b> {{ movAcc.name }}
                                                </v-col>
                                                <v-col cols=2 sm=2 md="2">
                                                    <v-icon
                                                        @click="deleteMovementAccount(movAcc.id)"
                                                        class="mx-2"
                                                        color="red"
                                                        size="24">mdi-minus-circle
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                            <div
                                                v-show="(movAcc.bsAccountCategory === 1 || movAcc.bsAccountCategory === 2) && movAcc.chavePIX === ''">
                                                <b>Banco:</b> {{ movAcc.bank }}
                                            </div>
                                            <div
                                                v-show="(movAcc.bsAccountCategory === 1 || movAcc.bsAccountCategory === 2) && movAcc.chavePIX === ''">
                                                <b>Agência:</b> {{ movAcc.agency }}
                                            </div>
                                            <div
                                                v-show="(movAcc.bsAccountCategory === 1 || movAcc.bsAccountCategory === 2) && movAcc.chavePIX === ''">
                                                <b>Conta Bancária:</b> {{ movAcc.bankAccount }}
                                            </div>
                                            <b>Saldo Inicial:</b> {{ movAcc.initialBalance | money }}<br>
                                            <b>Data do Saldo:</b> {{ movAcc.balanceDate }}<br>
                                            <div
                                                v-show="(movAcc.bsAccountCategory === 1 || movAcc.bsAccountCategory === 2) && movAcc.chavePIX !== ''">
                                                <b>Chave PIX:</b> {{ movAcc.chavePIX }}
                                            </div>
                                            <div
                                                v-show="(movAcc.bsAccountCategory === 1 || movAcc.bsAccountCategory === 2) && movAcc.chavePIX !== ''">
                                                <b>Tipo de Chave PIX:</b> {{ movAcc.chavePIXType }}
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12">
                            <v-row>
                                <v-col class="text-h5 text-left lyndus-color">
                                    Contas de Recebimento
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols=12 sm=12 md="6" v-for="recAcc in receiptAccounts"
                                       v-bind:key="'r'+recAcc.id">
                                    <v-card
                                        class="mx-auto fill-height text-left" tile
                                        style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols=10 xs=10>
                                                    <b>Nome:</b> {{ recAcc.name }}
                                                </v-col>
                                                <v-col cols=2 sm=2 md="2">
                                                    <v-icon
                                                        @click="deleteReceiptAccount(recAcc.id)"
                                                        class="mx-2"
                                                        color="red"
                                                        size="24"
                                                    >mdi-minus-circle
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                            <div cols="12" xs="12" class="mx-0">
                                                <b>Conta de Resgate:</b>
                                                {{ recAcc.bsAccountMovementName }}
                                            </div>
                                            <div cols="12" xs="12" class="mx-0">
                                                <b>Tipo:</b>
                                                {{ recAcc.accountCategory }}
                                            </div>

                                            <div><b>Taxa:</b> {{ recAcc.fee }} %</div>
                                            <div v-if="recAcc.cardMachine">
                                                <b>Maquininha:</b>
                                                <span v-show="recAcc.cardMachine === 'own'"> Própria</span>
                                                <span v-show="recAcc.cardMachine === 'rent'"> Aluguel</span>
                                                <span
                                                    v-show="recAcc.cardMachine === 'installments'"> Parcelado</span>
                                            </div>

                                            <div
                                                v-show="recAcc.cardMachine === 'rent' || recAcc.cardMachine === 'installments'">
                                                <b>Valor da Máquina:</b> {{ recAcc.valueMachine | money }}
                                            </div>
                                            <div
                                                v-show="recAcc.cardMachine === 'rent' || recAcc.cardMachine === 'installments'">
                                                <b>Dia de Pagamento:</b> {{ recAcc.dayMachine }}
                                            </div>
                                            <div v-show="recAcc.cardMachine === 'installments'">
                                                <b>Parcelas:</b> {{ recAcc.installmentMachine }}
                                            </div>

                                            <div
                                                v-show="recAcc.cardCycle === 'dynamic' || recAcc.cardCycle === 'fixed'">
                                                <b>Ciclo: </b> <span
                                                v-show="recAcc.cardCycle === 'dynamic'"> Dinâmico</span><span
                                                v-show="recAcc.cardCycle === 'fixed'"> Fixo</span>
                                            </div>

                                            <div v-show="recAcc.cardCycle === 'dynamic'"><b>Dia
                                                de Resgate:</b> {{ recAcc.rescueDay }}
                                            </div>
                                            <div v-show="recAcc.cardCycle === 'fixed'"><b>Dia de
                                                Fechamento:</b> {{ recAcc.closingDay }}
                                            </div>
                                            <div v-show="recAcc.cardCycle === 'fixed'"><b>Dia de
                                                Recebimento:</b> {{ recAcc.receiptDay }}
                                            </div>

                                            <v-col cols="12" xs="12" v-show="recAcc.installment"><b>Parcelamento</b>
                                            </v-col>
                                            <div v-show="recAcc.installment"><b>Quantidade de
                                                Parcelas: </b> {{ recAcc.installmentMax }}
                                            </div>
                                            <div
                                                v-show="recAcc.installment && recAcc.installmentFeeBy === 'store'">
                                                <b>Juro de Parcelamento do Estabelecimento </b>
                                            </div>
                                            <div
                                                v-show="recAcc.installment && recAcc.installmentFeeBy === 'client'">
                                                <b>Juro de Parcelamento Repassado ao Cliente </b>
                                            </div>

                                            <div v-show="recAcc.installment &&  recAcc.freeFee">
                                                <b>Parcelamento sem Juros</b>
                                            </div>
                                            <div v-show="recAcc.installment &&  recAcc.freeFee">
                                                <b>Número de Parcelas:</b> {{ recAcc.installmentsFreeFee }}
                                            </div>


                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

    </v-row>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import {
    BANK_ACCOUNT_CREATE,
    BANK_ACCOUNTS_GET,
    FINANCE_CREATE,
    FINANCE_SEARCH,
    MOVEMENT_ACCOUNTS_GET,
    RECEIPT_ACCOUNTS_GET,
    MOVEMENT_ACCOUNT_DELETE,
    RECEIPT_ACCOUNT_DELETE
} from "@/store/actions/financial.type";
import {
    FINANCIAL_RESET_STATE,
    SET_FINANCE_PAGINATION
} from "@/store/mutations/financial.type";
import {banks} from "@/common/banks.list";

export default {
    name: "financial",
    directives: {mask},
    components: {},
    // async beforeRouteUpdate(to, from, next) {
    //     // Reset state if user goes from /editor/:id to /editor
    //     // The component is not recreated so we use to hook to reset the state.
    //     await store.commit(FINANCIAL_RESET_STATE);
    //     return next();
    // },
    async beforeRouteEnter(to, from, next) {
        await store.commit(FINANCIAL_RESET_STATE);
        await store.dispatch(MOVEMENT_ACCOUNTS_GET);
        await store.dispatch(RECEIPT_ACCOUNTS_GET);

        return next();
    },
    data: () => ({

        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],

        myPlan: {
            day: 10,
            value: 89.90,

        },

        selected: [],
        options: {},
        headers: [
            {text: "Data", align: "left", value: "date"},
            {text: "Valor", value: "value"},
            {text: "Status", value: "status"},
            // {text: "Valor Total", value: "totalValue"},
            // {text: "Usuário", value: "username"},
            {text: "Documento", value: "actions", sortable: false}
        ],
        tab: null,


        data: [
            {id: 1, date: '2022-02-09', value: 89.90, status: 'Aguardando Pagamento'},
            {id: 2, date: '2022-01-10', value: 89.90, status: 'Pago'},
            {id: 3, date: '2021-12-11', value: 89.90, status: 'Pago'},
            {id: 4, date: '2021-11-07', value: 89.90, status: 'Pago'},
            {id: 5, date: '2021-10-10', value: 89.90, status: 'Pago'},
            {id: 6, date: '2021-09-08', value: 89.90, status: 'Pago'},
        ],

        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogBankAccount: false,


        dialogBankRemove: false,
        socialEdit: false,
        updateLogo: null,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],


    }),

    methods: {
        querySelections(v) {
            this.localBanks = banks.filter((e) => {
                return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
            });
        },
        async submitBankAccount() {
            if (this.$refs.formBankAccount.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true);

                await this.$store
                    .dispatch(BANK_ACCOUNT_CREATE, this.bankAccount)
                    .then(async () => {
                        this.$store.commit(CHANGE_PROGRESS, false);

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        await store.dispatch(BANK_ACCOUNTS_GET);

                        this.$refs.formBankAccount.resetValidation();
                        this.$refs.formBankAccount.reset();

                        this.dialogBankAccount = false;
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.dialogBankAccount = false;
                        MOVEMENT_ACCOUNTS_GET
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar dados bancários";
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar dados bancários: " + response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },

        deleteMovementAccount(movementAccountID) {
            this.$store.commit(CHANGE_PROGRESS, true);

            this.$store.dispatch(MOVEMENT_ACCOUNT_DELETE, movementAccountID)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Conta excluída com sucesso";
                    this.dialogmovementAccount = false;
                    this.$router.go();
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.dialogmovementAccount = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir conta";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = "Erro ao excluir conta: " + response.data.message;
                    }
                });
        },

        deleteReceiptAccount(receiptAccountID) {
            this.$store.commit(CHANGE_PROGRESS, true);

            this.$store.dispatch(RECEIPT_ACCOUNT_DELETE, receiptAccountID)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Conta excluída com sucesso";
                    this.dialogmovementAccount = false;
                    this.$router.go();
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.dialogmovementAccount = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir conta";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = "Erro ao excluir conta: " + response.data.message;
                    }
                });
        },

        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."))
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";

            return true
        },
        bankRulesValid(v) {
            if (!this.bankAccount.chavePIX) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        pixRulesValid(v) {
            if (!this.bankAccount.bank && !this.bankAccount.agency && !this.bankAccount.account) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },


        removeBankDialog(id, index) {
            this.dialogBankRemove = true;
            this.bankAccount.id = id
            this.bankAccountIndex = index
        },
        dialogRescueBalanceDialog() {

            this.dialogRescueBalance = true;
            for (let i = 0; i < this.bankAccounts.length; i++) {
                if (this.bankAccounts[i].default) {
                    this.balanceRequest.bankID = this.bankAccounts[i].id
                    return
                }
            }

        },
        loadExtract() {
            this.buscar()
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options

            store.commit(SET_FINANCE_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            await store.dispatch(FINANCE_SEARCH);
        },
        async rescueBalance() {

            this.dialogRescueBalance = false;

            await this.$store
                .dispatch(FINANCE_CREATE, this.balanceRequest)
                .then(response => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";

                    this.$refs.formBalanceRescue.reset()
                    this.$router.push({
                        name: "financialView",
                        params: {id: response.data.id}
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao salvar: " + response.data.message;
                    }
                });


        },

        //Dialog Balance - Botão Liberar Saldo

        closeBalance() {
            this.$refs.formBalance.resetValidation();
            this.socialEdit = false;
            this.dialogBalance = false;
            this.social.socialID = null;
            this.social.url = "";
        },


        //Dialog Bank Account - Botão Adicionar (Conta)
        closeBankAccount() {
            this.$refs.formBankAccount.resetValidation();
            this.socialEdit = false;
            this.dialogBankAccount = false;
            this.social.socialID = null;
            this.social.url = "";
        },


    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
    },
    computed: {

        filteredData(){
            return this.movementAccounts.filter(item => item.deleted === false)
        },
        ...
            mapGetters(["snackbar", "finances", "financePagination", "bankAccount", "accountCategory", "receiptAccounts", "movementAccounts"]),
    }
    ,
}
;
</script>